import React, { useEffect, useRef, useState } from "react";
import "./App.css";
import EnvironmentProvider from "./Analytics/EnvironmentContext";

function App() {
  const [shouldUpdate, setShouldUpdate] = useState(true);
  const containerRef = useRef(null);

  useEffect(() => {
    if (shouldUpdate) setShouldUpdate(false);
  }, [shouldUpdate]);

  return (
    <div ref={containerRef}>
      <EnvironmentProvider
        initialProps={{
          type: "health-insurance-interactive",
          rootEl: containerRef.current,
        }}
        data={{
          type: "health-insurance-interactive",
        }}
      ></EnvironmentProvider>
    </div>
  );
}

export default App;
